import { PrivilegeEnum as a } from "@hprofits/shared/auth";
import { z as s } from "zod";
import { ocPrivate as t } from "../common/auth/procedure-builders.js";
import "../swagger/security.js";
import { SwaggerTags as e } from "../swagger/tags.js";
import { BannerSizesResponseSchema as o, AdTagsResponseSchema as r, SspsResponseSchema as i, AdUnitSitesResponseSchema as n, AdvertisersResponseSchema as u, AdUnitOwnersResponseSchema as m, BlacklistConditionParamsResponseSchema as p, BlacklistBanTypesResponseSchema as c, BlacklistStatusesResponseSchema as d, CpaAutoRulesResponseSchema as y, ContentTypeResponseSchema as l, DealTypesResponseSchema as h, LanguagesResponseSchema as g, CategoriesResponseSchema as T, BrowserTypesResponseSchema as R, DeviceTypeResponseSchema as A, AdUnitTypeQuerySchema as I, AdUnitTypeResponseSchema as S, OsQuerySchema as C, OsResponseSchema as b, CountriesQuerySchema as O, CountriesResponseSchema as D } from "./schemas.js";
const k = {
  dictionary: {
    /**
     * List all countries.
     * Accepts optional `mode` query param: 'flat' (default) returns code+name only,
     * 'full' returns countries with nested regions.
     */
    getCountries: t().route({
      method: "GET",
      path: "/dictionary/countries",
      summary: "List all countries",
      tags: [e.DICTIONARY.name]
    }).input(O).output(D).errors({}),
    getOperatingSystems: t().route({
      method: "GET",
      path: "/dictionary/oses",
      summary: "List all operating systems",
      tags: [e.DICTIONARY.name]
    }).input(C).output(b).errors({}),
    getAdUnitTypes: t().route({
      method: "GET",
      path: "/dictionary/adunit-types",
      summary: "List all ad unit types",
      tags: [e.DICTIONARY.name]
    }).input(I).output(S).errors({}),
    getDeviceTypes: t().route({
      method: "GET",
      path: "/dictionary/device-types",
      summary: "List all device types",
      tags: [e.DICTIONARY.name]
    }).input(s.object({})).output(A).errors({}),
    getBrowserTypes: t().route({
      method: "GET",
      path: "/dictionary/browser-types",
      summary: "List all browser types",
      tags: [e.DICTIONARY.name]
    }).input(s.object({})).output(R).errors({}),
    getCategories: t().route({
      method: "GET",
      path: "/dictionary/categories",
      summary: "List all categories",
      tags: [e.DICTIONARY.name]
    }).input(s.object({})).output(T).errors({}),
    getLanguages: t().route({
      method: "GET",
      path: "/dictionary/languages",
      summary: "List all languages",
      tags: [e.DICTIONARY.name]
    }).input(s.object({})).output(g).errors({}),
    getDealTypes: t().route({
      method: "GET",
      path: "/dictionary/deal-types",
      summary: "List all deal types (mapped to campaign priority)",
      tags: [e.DICTIONARY.name]
    }).input(s.object({})).output(h).errors({}),
    getContentTypes: t().route({
      method: "GET",
      path: "/dictionary/content-types",
      summary: "List all content-types (aka niches)",
      tags: [e.DICTIONARY.name]
    }).input(s.object({})).output(l).errors({}),
    getCpaAutoRules: t([a.ReadAdmin]).route({
      method: "GET",
      path: "/dictionary/cpa-auto-rules",
      summary: "List all CPA auto-rules",
      tags: [e.DICTIONARY.name]
    }).input(s.object({})).output(y).errors({}),
    getBlacklistStatuses: t([a.ReadAdmin]).route({
      method: "GET",
      path: "/dictionary/blacklist-statuses",
      summary: "List all blacklist ban durations",
      tags: [e.DICTIONARY.name]
    }).input(s.object({})).output(d).errors({}),
    getBlacklistBanTypes: t([a.ReadAdmin]).route({
      method: "GET",
      path: "/dictionary/blacklist-ban-types",
      summary: "List all blacklist ban types",
      tags: [e.DICTIONARY.name]
    }).input(s.object({})).output(c).errors({}),
    getBlacklistConditionParams: t([a.ReadAdmin]).route({
      method: "GET",
      path: "/dictionary/blacklist-condition-params",
      summary: "List all metrics a blacklist rule condition can compare",
      tags: [e.DICTIONARY.name]
    }).input(s.object({})).output(p).errors({}),
    /**
     * Distinct owners of at least one non-deleted ad unit — a facet for the ad unit list, not every
     * user in the system.
     */
    getAdUnitOwners: t([a.ReadAdmin]).route({
      method: "GET",
      path: "/dictionary/adunit-owners",
      summary: "List distinct owners of ad units",
      tags: [e.DICTIONARY.name]
    }).input(s.object({})).output(m).errors({}),
    /**
     * Live users with the advertiser role - the owners a goal can belong to.
     */
    getAdvertisers: t([a.ReadAdmin]).route({
      method: "GET",
      path: "/dictionary/advertisers",
      summary: "List advertisers",
      tags: [e.DICTIONARY.name]
    }).input(s.object({})).output(u).errors({}),
    /**
     * Every live site with its owner and status — a facet for the ad unit list.
     */
    getAdUnitSites: t([a.ReadAdmin]).route({
      method: "GET",
      path: "/dictionary/adunit-sites",
      summary: "List live sites with their owner and status",
      tags: [e.DICTIONARY.name]
    }).input(s.object({})).output(n).errors({}),
    /**
     * Live SSPs — options for the per-SSP traffic source filter (`traffic_source_id` in statistics).
     */
    getSsps: t([a.SplitTrafficSourceBySsp]).route({
      method: "GET",
      path: "/dictionary/ssps",
      summary: "List live SSPs",
      tags: [e.DICTIONARY.name]
    }).input(s.object({})).output(i).errors({}),
    /**
     * Ad compliance tags for landings and creatives; open to any authenticated user because
     * advertisers pick them in the landing editor.
     */
    getAdTags: t().route({
      method: "GET",
      path: "/dictionary/ad-tags",
      summary: "List all ad compliance tags",
      tags: [e.DICTIONARY.name]
    }).input(s.object({})).output(r).errors({}),
    /**
     * Banner sizes for a banner creative without a file; open to any authenticated user because
     * advertisers pick one in the creative editor.
     */
    getBannerSizes: t().route({
      method: "GET",
      path: "/dictionary/banner-sizes",
      summary: "List the sizes of a custom-content banner creative",
      tags: [e.DICTIONARY.name]
    }).input(s.object({})).output(o).errors({})
  }
};
export {
  k as dictionaryContract
};
//# sourceMappingURL=contract.js.map
